<!--
 * @Autor: lianxiben
 * @Date: 2023-08-14 20:08:02
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-08-16 16:29:34
-->
<template>
    <div>
        <div class="pc-container">
        </div>
        <div class="card-page" :class="[!isBuildShare ? 'now-font-type' : '']">
            <!-- 首屏 -->
            <div class="fir-bgc" :class="[pageType == 1 ? 'fir-bgc-show' : '']" v-if="pageType == 1">
                <div class="top-left "></div>
                <div class="top-mid "></div>
                <div class="top-right "></div>
                <div class="left-line"></div>
                <div class="right-line"></div>
                <div class="bot-left"></div>
                <div class="bot-mid"></div>
                <div class="bot-right"></div>
                <div class="stars-space">
                    <div class="star star-a"></div>
                    <div class="star star-b"></div>
                    <div class="star star-c"></div>
                    <div class="star star-d"></div>
                    <div class="star star-e"></div>
                    <div class="star star-f"></div>
                    <div class="star star-g"></div>
                </div>

                <div class="fir-title">
                    <div class="title-body">
                        <div class="tips-icon" @click="tipsType = true"></div>
                    </div>
                </div>
                <div class="sakura-role"></div>
                <div class="sakura-winds"></div>
                <div class="fir-btn">
                    <div class="btn-img" @click="goPageNext(2)">
                    </div>
                </div>
                <div class="popup_wrap tips-popup" v-show="tipsType" @click="tipsType = false">
                    <div class="tips-bgc"></div>
                </div>
            </div>

            <!-- 第二屏 -->
            <div class="fir-bgc" :class="[pageType == 2 ? 'fir-bgc-show' : '']" v-if="pageType == 2" @click="textNum = 15">
                <div class="top-left "></div>
                <div class="top-mid "></div>
                <div class="top-right "></div>
                <div class="left-line"></div>
                <div class="right-line"></div>
                <div class="bot-left"></div>
                <div class="bot-mid"></div>
                <div class="bot-right"></div>
                <div class="stars-space">
                    <div class="star star-a"></div>
                    <div class="star star-b"></div>
                    <div class="star star-c"></div>
                    <div class="star star-d"></div>
                    <div class="star star-e"></div>
                    <div class="star star-f"></div>
                    <div class="star star-g"></div>
                </div>

                <div class="sec-text-ani">
                    <div class="text-public text-public1" :class="textNum >= 1 ? 'show-text' : ''"></div>
                    <div class="text-public text-public2" :class="textNum >= 2 ? 'show-text' : ''"></div>
                    <div class="text-public text-public3" :class="textNum >= 3 ? 'show-text' : ''"></div>
                    <div class="text-public text-public4" :class="textNum >= 4 ? 'show-text' : ''"></div>
                    <div class="text-public text-public5" :class="textNum >= 5 ? 'show-text' : ''"></div>
                    <div class="text-public text-public6" :class="textNum >= 6 ? 'show-text' : ''"></div>
                    <div class="text-public text-public7" :class="textNum >= 7 ? 'show-text' : ''"></div>
                    <div class="text-public text-public8" :class="textNum >= 8 ? 'show-text' : ''"></div>
                    <div class="text-public text-public9" :class="textNum >= 9 ? 'show-text-sec' : ''"></div>
                    <div class="text-public text-public91" :class="textNum >= 10 ? 'show-text-sec' : ''"></div>
                    <div class="text-public text-public10" :class="textNum >= 11 ? 'show-text-three' : ''"></div>
                    <div class="text-public text-public11" :class="textNum >= 12 ? 'show-text-four' : ''"></div>
                </div>

                <div class="shooting-star-line" :class="textNum >= 13 ? 'show-text-img' : ''"></div>
                <div :class="textNum >= 15 ? 'btn-sec-ani' : ''" v-if="textNum >= 15">
                    <div class="shooting-btn" :class="textNum >= 14 ? 'show-text-five' : ''" @click="goPageNext(3)"></div>
                </div>
            </div>
            <!-- 第三屏 -->
            <div class="fir-bgc" :class="[pageType == 3 ? 'fir-bgc-show' : '']" v-if="pageType == 3">
                <div class="top-left "></div>
                <div class="top-mid "></div>
                <div class="top-right "></div>
                <div class="left-line"></div>
                <div class="right-line"></div>
                <div class="bot-left"></div>
                <div class="bot-mid"></div>
                <div class="bot-right"></div>
                <div class="stars-space" v-if="nowType != 5 && nowType != 6">
                    <div class="star star-a"></div>
                    <div class="star star-b"></div>
                    <div class="star star-c"></div>
                    <div class="star star-d"></div>
                    <div class="star star-e"></div>
                    <div class="star star-f"></div>
                    <div class="star star-g"></div>
                </div>

                <!-- 进度条 -->
                <div class="progress-container">
                    <div class="progress-bar">
                        <div class="progress" :style="{ width: progress + '%' }"
                            :class="[progress > 0 ? 'show-progress' : '']">
                        </div>
                        <div class="star-icon" :style="{ left: (progress - 6) + '%' }"></div>
                    </div>
                    <div>
                        <span v-if="nowType < 8">{{ nowType }}</span>
                        <span v-else>7</span>
                        /7
                    </div>
                </div>

                <div class="question-list-container">
                    <div class="text-icon" v-if="nowType == 1"></div>
                    <div class="text-icon-sec" v-if="nowType == 2"></div>
                    <div class="text-icon-three" v-if="nowType == 3"></div>
                    <div class="text-icon-four" v-if="nowType == 4"></div>
                    <div class="text-icon-five" v-if="nowType == 5"></div>
                    <div class="text-icon-six" v-if="nowType == 6"></div>
                    <div class="text-icon-seven" v-if="nowType == 7"></div>
                    <div class="text-icon-eight" v-if="nowType == 8"></div>

                    <div class="choice-list" v-for="(item, index) in indexList" :key="index">
                        <div v-if="nowType == index + 1">
                            <div class="choice-btn" v-for="(subItem, subIndex) in item" :key="subIndex"
                                @click="choice(subItem.type)">
                                {{ subItem.type }}.{{ subItem.text }}
                                <div class="btn-star"></div>
                            </div>
                        </div>
                    </div>
                    <div class="over-input" v-if="nowType == 8">
                        <input type="text" placeholder="输入你的昵称......" v-model="nickname" />
                    </div>
                    <div class="over-btn" v-if="nowType == 8" @click="goPageNext(4)">
                    </div>
                </div>
                <div class="back-btn" v-if="nowType != 1 && nowType != 8" @click="deleteList()"></div>
                <div class="fir-que-bgc" v-if="nowType == 1">
                </div>
                <div class="sec-que-bgc" v-if="nowType == 2">
                    <div class="star-bgc">
                        <div class="fir-star"></div>
                        <div class="sec-star"></div>
                        <div class="third-star"></div>
                    </div>
                </div>
                <div class="four-que-bgc" v-if="nowType == 4">
                    <div class="music-bgc">
                        <div class="music-icon1"></div>
                        <div class="music-icon2"></div>
                        <div class="music-icon3"></div>
                        <div class="music-icon4"></div>
                        <div class="music-icon5"></div>
                        <div class="music-icon6"></div>
                        <div class="music-icon7"></div>
                        <div class="music-icon8"></div>
                        <div class="music-icon9"></div>
                        <div class="music-icon10"></div>
                    </div>
                </div>
                <div class="five-que-bgc" v-if="nowType == 5"></div>
            </div>
            <!-- 第四屏 -->
            <div class="fir-bgc" :class="[pageType == 4 ? 'fir-bgc-show' : '']" v-if="pageType == 4">
                <div class="top-left "></div>
                <div class="top-mid "></div>
                <div class="top-right "></div>
                <div class="left-line"></div>
                <div class="right-line"></div>
                <div class="bot-left"></div>
                <div class="bot-mid"></div>
                <div class="bot-right"></div>
                <div class="stars-space">
                    <div class="star star-a"></div>
                    <div class="star star-b"></div>
                    <div class="star star-c"></div>
                    <div class="star star-d"></div>
                    <div class="star star-e"></div>
                    <div class="star star-f"></div>
                    <div class="star star-g"></div>
                </div>

                <div class="result-title"></div>
                <div>
                    <div class="left-container">
                        <div class="character-tips"></div>
                        <div class="character-text" v-if="maxType == 'rain'">顽皮、可爱</div>
                        <div class="character-text" v-if="maxType == 'tree'">温柔、友善</div>
                        <div class="character-text" v-if="maxType == 'slience'">安静、独处</div>
                        <div class="character-text" v-if="maxType == 'flower'">快乐至上</div>
                        <div class="character-text" v-if="maxType == 'shield'">守护、坚持</div>
                        <div class="character-text" v-if="maxType == 'fighting'">坚定、勇气</div>
                        <div class="card-title"></div>
                        <div :class="'card-tips-' + maxType"></div>
                        <div class="card-line"></div>
                        <div class="bot-text-container">
                            <div class="nickname">
                                {{ nickname || '参与用户' }}
                            </div>
                            <div class="bot-title-container">
                                与
                                <span v-if="maxType == 'rain'">【雨】</span>
                                <span v-if="maxType == 'tree'">【树】</span>
                                <span v-if="maxType == 'slience'">【静】</span>
                                <span v-if="maxType == 'flower'">【花】</span>
                                <span v-if="maxType == 'shield'">【盾】</span>
                                <span v-if="maxType == 'fighting'">【斗】</span>
                                的契合度为
                            </div>
                            <span class="bot-title-num">{{ firNum }}%</span>
                            <div class="bot-title-num-container">
                                <div class="bot-title-left">超越了</div>
                                <span class="bot-title-num">{{ secNum }}%</span>
                            </div>
                            <div class="bot-title-num-container">的入梦者</div>
                        </div>
                    </div>
                    <div class="right-container">
                        <div class="card-container">
                            <div class="star-bgc-light"></div>
                            <div class="card-type-container">
                                <div :class="maxType + '-card'">
                                    <div class="card-light"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="bot-btn-list" v-if="!isBuildShare">
                    <div class="share-btn" @click="shareBtn()"></div>
                    <div class="web-btn" @click="goWeb()"></div>
                </div>

                <div class="share-container">
                    <div class="share-bgc" ref="imgDown">
                        <div class="character-text-share" v-if="maxType == 'rain'">顽皮、可爱</div>
                        <div class="character-text-share" v-if="maxType == 'tree'">温柔、友善</div>
                        <div class="character-text-share" v-if="maxType == 'slience'">安静、独处</div>
                        <div class="character-text-share" v-if="maxType == 'flower'">快乐至上</div>
                        <div class="character-text-share" v-if="maxType == 'shield'">守护、坚持</div>
                        <div class="character-text-share" v-if="maxType == 'fighting'">坚定、勇气</div>
                        <div class="share-tips" :class="'card-tips-' + maxType"></div>

                        <div class="bot-text-container share-text-container">
                            <div class="nickname">
                                {{ nickname || '参与用户' }}
                            </div>
                            <div class="bot-title-container">
                                与
                                <span v-if="maxType == 'rain'">【雨】</span>
                                <span v-if="maxType == 'tree'">【树】</span>
                                <span v-if="maxType == 'slience'">【静】</span>
                                <span v-if="maxType == 'flower'">【花】</span>
                                <span v-if="maxType == 'shield'">【盾】</span>
                                <span v-if="maxType == 'fighting'">【斗】</span>
                                的契合度为
                            </div>
                            <span class="bot-title-num">{{ firNum }}%</span>
                            <div class="bot-title-num-container">
                                <div class="bot-title-left">超越了</div>
                                <span class="bot-title-num">{{ secNum }}%</span>
                            </div>
                            <div class="bot-title-num-container">的入梦者</div>
                        </div>
                        <div class="share-card-type-container">
                            <div :class="maxType + '-card'">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="share-result-popup" v-if="isBuildShare" @click="closeShare()">
                    <div v-if="shareImg">
                        <div class="share-top-text" v-if="isWechat">
                            <div>点击...分享活动</div>
                            <div class="right-icon"></div>
                        </div>
                        <img :src="shareImg" alt="" />
                        <div class="share-bot-text">
                            > 长按图片保存 &lt;
                        </div>
                    </div>
                </div>

                <!-- <div class="text">
                <button @click="getsss()">获取权限</button>
                <h4>alpha: {{ alpha }}</h4>
                <h4>beta: {{ beta }}</h4> 
                <h4>gamma: {{ gamma }}</h4>
            </div> -->
            </div>
            <div class="music-container">
                <audio ref="bgcMusic" controls="controls" auto loop>
                    <source src="https://download4.qcplay.com/sakura/cardTest/card.mp3">
                </audio>
            </div>
        </div>
    </div>
</template>
<script>
import { generateCanvasImage } from '@/utils/share';
import { Toast, Indicator } from "mint-ui";
import { mapActions } from 'vuex';
import { getTimeStamp, buriedLogger } from '@/utils/utils'
import share from 'vue-social-share'

export default {
    data () {
        return {
            tipsType: false,
            showDonw: true,
            indexList: [
                [{ type: 'A', text: '悲伤' }, { type: 'B', text: '喜悦' }, { type: 'C', text: '安宁' },],
                [{ type: 'A', text: '隐秘的暗恋' }, { type: 'B', text: '闪闪发光的获奖瞬间' }, { type: 'C', text: '无忧无虑的乡村生活' },],
                [{ type: 'A', text: '成为一个平凡而温柔的大人' }, { type: 'B', text: '成为一个聪明而强大的大人' }, { type: 'C', text: '我不想成为大人' },],
                [{ type: 'A', text: '晚安曲' }, { type: 'B', text: '童谣' }, { type: 'C', text: '异国曲调' },],
                [{ type: 'A', text: '我还能再回来吗？' }, { type: 'B', text: '你是谁？' }, { type: 'C', text: '为什么我会来到这里？' },],
                [{ type: 'A', text: '明媚阳光倾洒窗台' }, { type: 'B', text: '乌云笼罩遍野' }, { type: 'C', text: '暴雨倾盆打落花叶' },],
                [{ type: 'A', text: '去深入调查梦的意义' }, { type: 'B', text: '记录下来，等待下一次梦境' }, { type: 'C', text: '放宽心，过好现在的生活' },],
            ],
            choiceItem: [],
            nowType: 1,
            rain: 0,//雨
            fighting: 0, //斗
            shield: 0,//盾
            tree: 0,//树
            slience: 0,//静
            flower: 0,//花
            pageType: 1,//当前页面
            textNum: 0,//文字内容显示序号
            progress: 14,//进度条
            alpha: 0,
            beta: 0,
            gamma: 0,
            showShare: false,
            shareImg: '',
            isBuildShare: false,
            maxType: 'rain',//卡牌最终类型
            nickname: '',//玩家姓名
            firNum: '',
            secNum: '',
            titles: '小樱',
            share_config: {
                url: `${location.href}`, // 网址，默认使用 window.location.href
                source: "封印解除！快来看看与你性格最契合的是哪张库洛牌吧~", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
                title: "封印解除！快来看看与你性格最契合的是哪张库洛牌吧~", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                description: "封印解除！快来看看与你性格最契合的是哪张库洛牌吧~", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                image: "", // 图片, 默认取网页中第一个img标签
                sites: ["weibo", "qzone", "qq", "wechat"], // 启用的站点
                // disabled: ["google", "facebook", "twitter"], // 禁用的站点
                wechatQrcodeTitle: "微信扫码分享", // 微信二维码提示文字
                wechatQrcodeHelper: "",
            },
            isWechat: false

        }
    },
    components: {
        share
    },
    created () {
        document.title = '测一测你最契合的库洛牌';
        this.$nextTick(() => {
            this.isSetShare()
            this.testNowUa()
        })
    },
    mounted () {
        // 埋点
        const bl = buriedLogger('sakura', '小樱_卡片相性页面');
        this.logger = bl
        document.addEventListener("WeixinJSBridgeReady", () => {
            this.$refs.bgcMusic.play()
        }, false);

        const _ResizeObserver = window.ResizeObserver;
        window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
            constructor(callback) {
                callback = debounce(callback, 16);
                super(callback);
            }
        };
    },
    methods: {
        shareBtn () {
            this.isBuildShare = true;
            Indicator.open();
            this.logger.sum('小樱_卡牌相性_分享按钮');
            setTimeout(() => {
                this.generateShareImage()
            }, 2000);
        },
        generateShareImage () {
            generateCanvasImage(this.$refs.imgDown)
                .then((canvas) => {
                    Indicator.close();
                    this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
                })
                .catch(() => {
                    Indicator.close();
                });
        },

        getsss () {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            //判断是ios还是安卓
            if (isiOS) {
                if (window.DeviceOrientationEvent) {
                    window.DeviceOrientationEvent.requestPermission().then(state => {
                        if (state === "granted") {//允许
                            console.log("用户允许", state)
                            this.monitor();
                        } else {
                            alert('apply permission state: ' + state);
                        }
                    })
                } else {
                    this.monitor();
                }
            } else if (isAndroid) {
                this.monitor();
            }
        },
        monitor () {
            let that = this;
            window.addEventListener("deviceorientation", function (e) {
                that.alpha = e.alpha;
                that.beta = e.beta;
                that.gamma = e.gamma;
                // 做你想做的操作
            })
        },
        // 前往下一页
        goPageNext (e) {
            if (this.pageType == 1) { this.$refs.bgcMusic.play() }
            if (this.pageType == 2 && this.textNum < 15) return;
            if (this.pageType == 3 && !this.nickname) return Toast('请输入昵称');
            if (this.pageType == 3) {
                this.logger.sum('小樱_卡牌相性_生成测试结果按钮');
            }
            this.pageType = e;
            if (e == 2) {
                this.textAni()
            }
        },
        // 渲染文字
        textAni () {
            if (this.textNum > 14) {
                clearInterval(this.timeInterval)
                return;
            }
            clearInterval(this.timeInterval)
            this.timeInterval = setInterval(() => {
                this.textNum = this.textNum + 1;
                this.textAni()
            }, 200);
        },
        // 选择题目
        choice (e) {
            this.choiceItem.push(e)
            this.nowType++;
            if (this.nowType < 8) {
                this.progress = (this.nowType) * 14.28;
            }
            else {
                this.progress = 100;
            }
            if (this.nowType == 8) {
                this.pageType = 7;
                setTimeout(() => {
                    this.pageType = 3
                }, 500);
                this.setToatl()
            }
        },
        // 返回上一个题目
        deleteList () {
            this.choiceItem.pop();
            this.nowType--;
            this.progress = (this.nowType - 1) * 14.28;

        },
        // 最后分数统计
        setToatl () {
            //计算雨牌
            //用一个二维数组存储每个选项对应的雨牌值
            let values = [
                [
                    [0, 4, 0],
                    [0, 1, 3],
                    [1, 0, 4],
                    [3, 2, 1],
                    [4, 0, 2],
                    [3, 3, 0],
                ],
                [
                    [0, 2, 4],
                    [3, 0, 2],
                    [2, 4, 2],
                    [1, 0, 0],
                    [4, 3, 0],
                    [0, 1, 1]
                ],
                [
                    [0, 0, 4],
                    [2, 4, 2],
                    [4, 1, 0],
                    [3, 2, 1],
                    [1, 0, 0],
                    [0, 3, 3]
                ],
                [
                    [0, 3, 3],
                    [2, 2, 2],
                    [4, 1, 0],
                    [3, 4, 0],
                    [1, 0, 1],
                    [0, 0, 4]
                ],
                [
                    [4, 0, 1],
                    [0, 1, 3],
                    [2, 0, 2],
                    [1, 3, 0],
                    [0, 2, 4],
                    [3, 4, 0]
                ],
                [
                    [3, 3, 0],
                    [0, 1, 2],
                    [0, 0, 3],
                    [4, 0, 1],
                    [2, 4, 0],
                    [1, 2, 4]
                ],
                [
                    [1, 0, 4],
                    [4, 1, 0],
                    [0, 3, 0],
                    [3, 4, 1],
                    [0, 2, 3],
                    [2, 0, 2]
                ]
            ];
            let properties = ['rain', 'fighting', 'shield', 'tree', 'slience', 'flower'];
            this.choiceItem.forEach((item, index) => {
                let itemIndex = item.charCodeAt(0) - 'A'.charCodeAt(0);
                properties.forEach((property, i) => {
                    this[property] += values[index][i][itemIndex];
                });
            });

            let codeNum = [
                this.rain, this.fighting, this.shield, this.tree, this.slience, this.flower
            ]
            let maxNum = Math.max(...codeNum)
            let maxIndex = codeNum.map(item => item).indexOf(maxNum)
            this.maxType = properties[maxIndex];
            this.firNum = (this.fullClose(80, 90)).toFixed(1);
            this.secNum = (this.fullClose(90.1, 99.9)).toFixed(1);
        },
        fullClose (n, m) {
            var result = Math.random() * (m + 1 - n) + n;
            while (result > m) {
                result = Math.random() * (m + 1 - n) + n;
            }
            return result;
        },
        // 关闭分享页
        closeShare () {
            this.shareImg = '';
            this.isBuildShare = false
        },
        goWeb () {
            this.logger.sum('小樱_卡牌相性_前往官网按钮');
            window.location.href = 'https://sakura.qingcijoy.com/leading/index.html'
        },
        // 判断当前是否为微信浏览器
        testNowUa () {
            const userAgent = navigator.userAgent.toLowerCase();
            // 判断是否在微信中打开
            if (userAgent.indexOf('micromessenger') !== -1) {
                this.isWechat = true;
            }

        },
        // 微信分享
        isSetShare () {
            this.setShare({
                link: `https://h5.qingcigame.com/sakura/cardTest/enter${getTimeStamp()}`,
                title: '测一测你最契合的库洛牌',
                imgUrl:
                    'https://download4.qcplay.com/sakura/active.jpg',
                desc: '封印解除！快来看看与你性格最契合的是哪张库洛牌吧~',
            })
        },
        //tap跳转
        goTapPage () {
            window.location.href = 'https://l.tapdb.net/lmiJ0GF9?channel=rep-rep_ikywqqjvfe8'
        },
        debounce (fn, delay, ...value) {
            let timer = null;
            return () => {
                let context = this;
                let args = value;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    fn.apply(context, args);
                }, delay);
            };
        },
        ...mapActions(['setShare']),
    },
}
</script>
<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/cardTest/index/index.vue